import React from "react";

export default function TextCarouselSeciton() {
  const items = ["Connect", "*", "Converse", "*", "Inspire", "*"];

  return (
    <div className="home-text-marquee">
      <div className="home-text-marquee__track">
        {[0, 1].map((groupIndex) => (
          <div className="home-text-marquee__group" key={groupIndex} aria-hidden={groupIndex === 1}>
            {items.map((word, index) => <span key={`${groupIndex}-${index}`}>{word}</span>)}
          </div>
        ))}
      </div>
    </div>
  );
}
